import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppContextComponent } from './app-context.component';

@Component({
  imports: [RouterModule, AppContextComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'ng-partner-shell';
}
